import { useQuery } from '@tanstack/react-query';
import { aiUsageApi } from '../api/aiUsage';
import type { AiUsageStats, PaginatedAiUsage } from '../api/aiUsage';

export function useAiUsageLogs(page = 1, perPage = 25) {
  return useQuery<PaginatedAiUsage>({
    queryKey: ['ai-usage-logs', page, perPage],
    queryFn:  () => aiUsageApi.list(page, perPage),
    staleTime: 60_000,
  });
}

export function useAiUsageStats(days = 30) {
  return useQuery<{ data: AiUsageStats }>({
    queryKey: ['ai-usage-stats', days],
    queryFn:  () => aiUsageApi.stats(days),
    staleTime: 120_000,
  });
}
